import { render, staticRenderFns } from "./MediaLibraryBrowser.vue?vue&type=template&id=7835b6af&scoped=true"
import script from "./MediaLibraryBrowser.vue?vue&type=script&lang=js"
export * from "./MediaLibraryBrowser.vue?vue&type=script&lang=js"
import style0 from "./MediaLibraryBrowser.vue?vue&type=style&index=0&id=7835b6af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7835b6af",
  null
  
)

export default component.exports